module.exports={
    PLAYGROUND:"/playground",
    CREATE:"/create",
    CREATEFORM:'/create/form',
    REPORTS:'/reports',
    REPORTID:'/reports/:id',
    MYLIBRARY:'/mylibrary',
    JOIN:'/join/:id',
    PROFILE:'/profile',
    LOGIN:'/login'
}